import { css } from 'aphrodite';
import { Controller } from 'react-hook-form';
import { Checkbox } from '../../../../../../web/components/Checkbox';
import { IFormField } from '../../../../../models/Api';
import { IFormValues } from '../../utils';
import { styleSheet } from '../styles';

interface IProps {
	field: IFormField<string>;
	control: any;
	formState: any;
	setValue: (name: keyof IFormValues, value: string | number | boolean) => void;
}

export const CheckboxInput = ({ field, control, formState, setValue }: IProps) => {
	return (
		<Controller
			name={`customProperties.${field.id}`}
			control={control}
			render={({ field: { ref, ...fieldProps } }) => {
				const fieldCheckboxOptions = field.options?.map(o => {
					const fieldCheckboxSelectedOptions: string[] = fieldProps?.value?.split(',') ?? [];

					/**
					 * Method to update the value of the field
					 * @param e {React.ChangeEvent<HTMLInputElement>}
					 * sets a {String} value of the field
					 */
					const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
						const newOptions = [...fieldCheckboxSelectedOptions];
						if (e.target.checked) {
							newOptions.push(o.id);
						} else {
							newOptions.splice(fieldCheckboxSelectedOptions.indexOf(o.id), 1);
						}

						setValue(`customProperties.${field.id}` as keyof IFormValues, `${newOptions.join(',')}`);
					};

					/**
					 * Use the onChange method to update the value of the field
					 */
					fieldProps.onChange = onChange;

					return (
						<Checkbox
							key={o.id}
							id={o.id}
							className={css(styleSheet.checkbox)}
							checked={fieldCheckboxSelectedOptions?.includes(o.id)}
							{...fieldProps}
						>
							<span>{o.label}</span>
						</Checkbox>
					);
				});

				return (
					<>
						{fieldCheckboxOptions}
						{formState?.errors.customProperties?.[field.id] && (
							<p className={css(styleSheet.errorMessage)}>{formState?.errors.customProperties[field.id]?.message}</p>
						)}
					</>
				);
			}}
		/>
	);
};
